import { pressItems } from "@/mocks/lawfirm";

export default function Press() {
  return (
    <section id="press" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-medium text-primary-700 tracking-wide">
            <i className="ri-newspaper-line"></i>
            PRESS
          </p>
          <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            <span className="md:hidden">
              광주부장판사·검사출신변호사
              <br />
              <span className="text-accent-600">언론보도</span>
            </span>
            <span className="hidden md:inline">
              광주부장판사·검사출신변호사 <span className="text-accent-600">언론보도</span>
            </span>
          </h2>
          <p className="mt-4 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
            25년 판사 퇴직 김평호 대표변호사와 법무법인 평율에 대한
            언론의 관심과 보도를 확인하실 수 있습니다.
          </p>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {pressItems.map((item) => (
            <a
              key={item.url}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="group flex flex-col h-full rounded-lg bg-white border border-background-200 p-6 hover:border-accent-400/60 hover:bg-accent-50/40 transition-colors"
            >
              <div className="flex items-center gap-3 text-xs">
                <span className="rounded bg-primary-50 px-3 py-1 font-semibold text-primary-700">
                  {item.media}
                </span>
                <span className="text-foreground-400">{item.date}</span>
              </div>
              <h3 className="mt-4 text-sm md:text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-700 transition-colors">
                {item.title}
              </h3>
              <p className="mt-3 hidden md:block text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                {item.desc}
              </p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-xs font-medium text-accent-600 pt-4 border-t border-background-100">
                기사 보기
                <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}